export default "/images/b3716df6b119eea72dd642e8de215329.avif";